export const TimeSettings = {
  DataHelperTimer: 900000,
  SessionLockerTimer: 300000,
  IdleModalTimer: 7200000
}
